export default __webpack_public_path__ + "static/media/M_Mapa.b20d2625.mp3";